<div class="detail">
  <div class="mb-10">
    <gmt-button uiSref="^"><i class="fa fa-chevron-left mr-5"></i> Zpět na případ</gmt-button>
  </div>
  <div [loading]="loading" *ngIf="loading"></div>
  <div *ngIf="!loading">
    <h1>{{ approvedInvestorName }}</h1>
    <fieldset>
      <legend>Základní údaje</legend>
      <div class="column-25">
        <label>Případ</label>
        <div class="cb pt-10">
          <b>{{ data.mpp.number }}</b>
          <div *ngFor="let title of data.titles" class="comma-list">
            {{ title.lv }} ({{ title.area.name }})
          </div>
          <div class="comma-list">
            <span *ngFor="let itemCaseSubject of data.caseSubjects">
              <a uiSref="symap.project.owners.detail" [uiParams]="{ ownerId: itemCaseSubject.subject.id, tab: 'about' }">
                {{ itemCaseSubject.subject | subjectName }}
              </a>
            </span>
          </div>
        </div>
      </div>
      <div class="column-25">
        <label>Typ</label>
        <div class="cb pt-10">{{ data.obligation.name }}</div>
      </div>
      <div class="column-25">
        <label>Stav</label>
        <div class="cb pt-10">{{ data.caseStatus.name }}<br/>{{ data.statusRespectiveDate | date }}</div>
      </div>
      <div class="column-25">
        <label>Přidělení LV</label>
        <div class="cb pt-10">
          {{ data.titles | titleUserUniqueNames }}
        </div>
      </div>
      <div class="column-100 mt-10">
        <label class="required">K datu</label>
        <div class="input"><input type="text" pick-a-date [(ngModel)]="date" [maxToday]="true" /></div>
      </div>
    </fieldset>

    <fieldset *ngIf="data.pfkRequired">
      <legend>Předběžná finanční kontrola (PFK) v Helios</legend>
      <div class="column-100">
        <label>Stav</label>
        <div class="info" *ngIf="!data.pfkStatus">Nezahájeno</div>
        <div class="info" *ngIf="data.pfkStatus == 'CREATED'">Zahájena PFK v Helios</div>
        <div class="info error-message" *ngIf="data.pfkStatus == 'FAILED'"><i class="fa fa-exclamation-triangle"></i> Nepovedlo se zahájit PFK v Helios</div>
        <div class="info" *ngIf="data.pfkStatus == 'FINISHED' && data.pfkCode == 0">PFK v Helios úspěšně ukončena</div>
        <div class="info error-message" *ngIf="data.pfkStatus == 'FINISHED' && data.pfkCode == 1"><i class="fa fa-exclamation-triangle"></i> PFK v Helios zamítnuta</div>
        <div class="info error-message" *ngIf="data.pfkStatus == 'FINISHED' && data.pfkCode == 2"><i class="fa fa-exclamation-triangle"></i> PFK v Helios zrušena</div>
      </div>
      <div class="column-100" *ngIf="!data.pfkStatus">
        <div class="input"><gmt-button [clickAction]="onPFK">Zahájit</gmt-button></div>
      </div>
      <div class="column-100" *ngIf="(data.pfkStatus == 'FINISHED' && data.pfkCode) || data.pfkStatus == 'FAILED'">
        <div class="input">
          <gmt-button [clickAction]="onPFK">Opakovat PFK</gmt-button>
          <gmt-button *ngIf="data.pfkCode == 1" class="red" [clickAction]="onDecline">{{ declinedInvestorName }}</gmt-button>
          <gmt-button *ngIf="data.pfkCode == 2" class="red" [clickAction]="onCancel">{{ cancelledName }}</gmt-button>
        </div>
      </div>
      <div class="column-100" *ngIf="!data.pfkStatus || data.pfkStatus == 'CREATED' || data.pfkCode">
        <div class="info">K odsouhlasení návrhu v MPV je nutné úspěšně provést PFK v Helios.</div>
      </div>
      <div class="column-100" *ngIf="data.pfkStatus == 'FAILED'">
        <div class="info">Pokud problém přetrvává nahlašte na Helpdesk ŘSD.</div>
      </div>
    </fieldset>

    <div>
      <gmt-button [clickAction]="onApprove" [gmtDisabled]="!isValid()">{{ approvedInvestorName }}</gmt-button>
    </div>
  </div>
</div>
